import Select, { Option } from '@ingka/select';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getStoreList, useAppContext } from '../contextProviders/AppContext';
import { Store } from '../types/model';

const StyledSelect = styled(Select)`
  min-width: auto;

  ${({ theme }) => `
    ${theme.breakpoints.lg} {
      min-width: auto;
    }
  `}

  select {
    text-wrap: wrap;
    height: auto;
  }
`;

type Props = {
  onChange: any;
  selectedStore: Store;
};

const sortStores = (a: Store, b: Store) => {
  if (a.storeName > b.storeName) {
    return 1;
  } else if (a.storeName < b.storeName) {
    return -1;
  }
  return 0;
};

const url = window.location.href;
var path = url.replace(/^https?:\/\//, '').split('/');

const StoreSelector = (props: Props) => {
  const { useSelector } = useAppContext();
  const { t } = useTranslation();
  const stores: Array<Store> = useSelector(getStoreList);

  return (
    <StyledSelect
      id="selectStore"
      onChange={props.onChange}
      value={props.selectedStore?.storeNo || ''}
      label={t('event.chooseLocation')}
      hintText={t('event.chooseLocation')}
    >
      {stores.sort(sortStores).map((s: Store, i) => {
        return <Option
          key={i}
          value={s.storeNo}
          name={
            ((["jp", "kr"].includes(path[1]) && path[2] === "en") ||
              (path[1] === "ca" && path[2] === "fr"))
              ? s.storeOtherName
              : s.storeName
          }
        />

      })}
    </StyledSelect>
  );
};

export default React.memo(StoreSelector);
